var exports = {
  "p_": "InvoiceList.module__list___NU42NW",
  "wx": "InvoiceList.module__header___NU42NW",
  "nM": "InvoiceList.module__row___NU42NW",
  "p6": "InvoiceList.module__date___NU42NW",
  "vj": "InvoiceList.module__amount___NU42NW",
};

module.exports = exports;
